var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"company"}},[(_vm.company)?_c('p',[_vm._v(_vm._s(_vm.company.name))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }